import { createFileRoute } from "@tanstack/react-router";
import { OutboundConnectionsPage } from "@/features/outbound/outbound-connections-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/weryfikacja-wysylek/polaczenia")({
	component: OutboundConnectionsPage,
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.weryfikacja-wysylek",
			location.pathname,
		);
	},
});
